import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Button,
  Link,
} from "@chakra-ui/react";

export default function CovidAlert() {
  return (
    <Alert
      status="info"
      variant="top-accent"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <AlertIcon />
      <AlertTitle mr={2}>Joe Wittman is retiring from bankruptcy law in June 2025</AlertTitle>
      <AlertDescription>
        <Button
          as={Link}
          rounded={"full"}
          color={"white"}
          bg={"blue.500"}
          size="sm"
          href="about"
        >
          Learn More
        </Button>
      </AlertDescription>
    </Alert>
  );
}
